import axios from "axios";
import '../utils/axios.interceptor';
import { urlCoreBack } from "../configs/config";

const epName = "v1/cristal-producto/";
const nameItemsText = "Productos de Cristales";
const nameItemText = "Producto de Cristal";
const itemGender = "M";
const elLa = itemGender === "M" ? "el" : "la";
//
// #############################################################################
//
export const getCristalProductos = async (params) => {
	let _params = {};
	let _errorMessage = `Se produjo un error al obtener ${nameItemsText}`;

	if (params) {
		if (params.id) {
			_params.id = params.id;
		}

		if (params.descripcion) {
			_params.descripcion = params.descripcion;
		}

		if (params.descripcionCorta) {
			_params.descripcion_corta = params.descripcionCorta;
		}

		if (params.idBlCrTipo) {
			_params.id_bl_cr_tipo = params.idBlCrTipo;
		}

		if (params.idCrOrigen) {
			_params.id_cr_origen = params.idCrOrigen;
		}

		if (params.idBlCrMarca) {
			_params.id_bl_cr_marca = params.idBlCrMarca;
		}

		if (params.idBlCrSubmarca) {
			_params.id_bl_cr_submarca = params.idBlCrSubmarca;
		}

		if (params.idBlCrDiagnostico) {
			_params.id_bl_cr_diagnostico = params.idBlCrDiagnostico;
		}

		if (params.idBlCrMaterial) {
			_params.id_bl_cr_material = params.idBlCrMaterial;
		}

		if (params.idBlCrMultifocal) {
			if (params.idBlCrMultifocal === "si") {
				_params.multifocal = "S";
			} else if (params.idBlCrMultifocal === "no") {
				_params.multifocal = "N";
			}
			else {
				_params.multifocal = "T";
			}
		}

		if (params.idBlCrColor) {
			_params.id_bl_cr_color = params.idBlCrColor;
		}

		if (params.idBlCrDisponibleOs) {
			if (params.idBlCrDisponibleOs === "si") {
				_params.disponible_obra_social = "S";
			} else if (params.idBlCrDisponibleOs === "no") {
				_params.disponible_obra_social = "N";
			}
			else {
				_params.disponible_obra_social = "T";
			}
		}

		if (params.estado) {
			let estado =
				params.estado === "habilitado"
					? "H"
					: params.estado === "deshabilitado"
						? "D"
						: "";
			_params.habilitado = estado;
		}

		if (params.rows) {
			_params.rows = params.rows;
		}

		if (params.first) {
			_params.first = params.first;
		}
	}

	try {
		const response = await axios({
			method: "GET",
			url: `${urlCoreBack}${epName}`,
			params: _params,
		});

		if (response.status === 200) {
			let _error = "status" in response.data && response.data.status === "error";
			if (!_error) {
				// si no hay error controlado
				response.ok = true;
				return response;
			}
		}

		// si hay algun error controlado

		console.log(_errorMessage);
		console.log(response);

		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	} catch (error) {
		console.log(_errorMessage);
		if (error.response) {
			// The request was made and the server responded with a status code that falls out of the range of 2xx
			console.log(error.response);
		} else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			console.log(error.request);
		} else {
			// Something happened in setting up the request that triggered an Error
			console.log(error);
		}
		let response = {};
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	}
};
//
// #############################################################################
//
export const getCristalProducto = async (params) => {
	let _errorMessage = `Se produjo un error al obtener ${nameItemsText}`;

	try {
		const response = await axios({
			method: "GET",
			url: `${urlCoreBack}${epName}`,
			params: params,
		});

		if (response.status === 200) {
			let _error = "status" in response.data && response.data.status === "error";
			if (!_error) {
				// si no hay error controlado
				response.ok = true;
				return response;
			}
		}

		// si hay algun error controlado

		console.log(_errorMessage);
		console.log(response);

		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	} catch (error) {
		console.log(_errorMessage);
		if (error.response) {
			// The request was made and the server responded with a status code that falls out of the range of 2xx
			console.log(error.response);
		} else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			console.log(error.request);
		} else {
			// Something happened in setting up the request that triggered an Error
			console.log(error);
		}
		let response = {};
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	}
};
//
// #############################################################################
//
export const saveCristalProducto = async (actionCrud, item) => {
	let _errorMessage = `No fue posible guardar ${elLa} ${nameItemText}`;

	let _id_usuario = localStorage.getItem("id_usuario");
	item.id_usuario = _id_usuario;

	try {
		let response = {};
		if (actionCrud === "new") {
			response = await axios({
				method: "POST",
				url: `${urlCoreBack}${epName}`,
				data: item,
			});
		} else if (actionCrud === "update") {
			response = await axios({
				method: "PUT",
				url: `${urlCoreBack}${epName}`,
				data: item,
			});
		} else if (actionCrud === "disable" || actionCrud === "enable") {
			response = await axios({
				method: "DELETE",
				url: `${urlCoreBack}${epName}`,
				params: {
					id: item.id,
					action: actionCrud,
					id_usuario: _id_usuario,
				},
			});
		}

		if (response.status === 200) {
			let _error = "status" in response.data && response.data.status === "error";
			if (!_error) {
				// si no hay error controlado
				response.ok = true;
				response.messageText =
					`${nameItemText}` +
					(actionCrud === "disable"
						? itemGender === "M"
							? " deshabilitado"
							: " deshabilitada"
						: actionCrud === "enable"
							? itemGender === "M"
								? " habilitado"
								: " habilitada"
							: itemGender === "M"
								? " guardado"
								: " guardada");
				response.messageSeverity = "success";
				return response;
			}

			if (response.data.code === "err-cristal-producto-already-exist") {
				response.ok = false;
				response.messageText = "Ya existe un producto con la misma descripción";
				response.messageSeverity = "error";
				return response;
			}
		}

		console.log(_errorMessage);
		console.log(response);

		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;

	} catch (error) {
		console.log(_errorMessage);
		if (error.response) {
			// The request was made and the server responded with a status code that falls out of the range of 2xx
			console.log(error.response);
		} else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			console.log(error.request);
		} else {
			// Something happened in setting up the request that triggered an Error
			console.log(error);
		}
		let response = {};
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	}
};

